const FbLoginModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET: (state, payload) => {
      state.data = payload
    }
  },
  actions: {},
  getters: {
    getAll: state => {
      return state.data
    }
    // getByOrderId: state => orderid => {
    //   return state.data.filter(item => item.idx === orderid)
    // },
    // getActive: state => {
    //   return state.data.filter(item => item.status === 'active')
    // }
  }
}

export default FbLoginModule
